import React from 'react';

//component
import WmsButton from './../../../components/WmsButton/WmsButton.jsx';
import WmsDropdown from './../../../components/WmsDropdown/WmsDropdown.jsx';
import WmsContainer from './../../../components/WmsContainer/WmsContainer.jsx';
import WmsModel from './../../../components/WmsModel/WmsModel.jsx';

import * as findOrdersService from '../findOrders.services.jsx';
import * as GlobalService from './../../../global_services';
import * as smallParcelSettingsServices from '../../../smallParcelSettings/small-parcel-settings.services.jsx';
import * as smallParcelService from '../../../smallParcel/smallParcel.service.jsx';
import * as papiDocumentUtil from '../../../smallParcel/papi-document.util.js';
import './packing-slips-model.scss';

export class PackingSlipsModel extends React.Component {

    constructor(props) {

        super(props);

        this.$rootScope = window;
        this.translate = window.translate;
        this.modalId = "#" + this.props.windowId + "shipSlipsModel";
        this._allDocumentTemplates = [];
        this.state = {
            selector: "order",
            gifPackageSlips: false,
            optionsPackingReports: [],
            optionsTemplateReports: [],
            optionsOutputTypes: [],
            indexOptionsPackingReports: 0,
            indexOptionsTemplateReports: 0,
            indexOptionsOutputTypes: 0,
            indexSelectedFormat: "pdf",
            indexPapiPackSlipScope: "shipment",
            usePapiPackingSlips: false,
            packingSlipSettingsFailed: false,
        }
        this.optionsPapiPackSlipScope = [
            { text: this.translate("Label_PapiPackSlipLayout_PerOrder"), value: "shipment" },
            { text: this.translate("Label_PapiPackSlipLayout_PerPackage"), value: "package" },
        ];
    }
    getSelectedCustomerIds = () => {
        var ids = papiDocumentUtil.distinctWmsCustomerIds(this.props.sharedSelectedCustomerIds);
        if (ids.length) return ids;
        var one = this.props.sharedSelectedOrderData && this.props.sharedSelectedOrderData.CustomerId;
        return papiDocumentUtil.distinctWmsCustomerIds(one);
    };

    isMixedCustomers = () => this.getSelectedCustomerIds().length > 1;

    isPapiPackingSlipEnabled = () => {
        return papiDocumentUtil.isPapiDocEnabled(GlobalService.GetRights(), "packingSlip");
    };

    catchDocumentCatalog = () => {
        GlobalService.notification("error", this.translate("Error_Papi_DocumentCatalog"));
        return null;
    };

    catchSettingsLoad = () => {
        GlobalService.notification("error", this.translate("Error_Papi_DocumentCatalog"));
        this.setState({ packingSlipSettingsFailed: true });
        return null;
    };

    rebuildTypeOptions = (format, savedValue, autoSelectFirst) => {
        const options = papiDocumentUtil.buildDocumentTypeOptions({
            docTypeKey: "packingSlip",
            papiTemplates: this._allDocumentTemplates,
            format: format,
            wmsCustomerIds: this.getSelectedCustomerIds(),
            includeDraft: false,
            includeEmptyRow: false,
            includeFormatSuffix: true,
            formatSuffixLabels: papiDocumentUtil.formatSuffixLabelsFromTranslate(this.translate),
        });
        const selection = papiDocumentUtil.resolveTemplateSelection(
            options,
            savedValue,
            autoSelectFirst !== false
        );
        return { options, selection };
    };

    applySsrsResponse = (response) => {
        let _combinedPackingShortShipArray = [];
        let _templateReports = [];
        let _outputTypes = [];
        const rights = GlobalService.GetRights ? GlobalService.GetRights() : {};
        const isShortShipEnabled = rights && rights.hasOwnProperty('Shipping.ShortShipEnabled');

        if (response.length >= 1) {
            let packingShip = response[0];
            for (let x = 0; x < packingShip.Reports.length; x++) {
                _combinedPackingShortShipArray.push(packingShip.Reports[x]);
            }
            _templateReports = packingShip.Templates;
            _outputTypes = packingShip.FileTypes;
        }
        if (response.length >= 2 && isShortShipEnabled) {
            let shortShip = response[1];
            for (let y = 0; y < shortShip.Reports.length; y++) {
                shortShip.Reports[y].Name = shortShip.Reports[y].Name + this.translate('Label_Append_Short_Ship');
                _combinedPackingShortShipArray.push(shortShip.Reports[y]);
            }
        }
        let tmpOpt = _combinedPackingShortShipArray.sort(function(first, second) {
            if(first.Name == 'Default' || second.Name == 'Default'){ return -1; }
            var firstReport = first.Name.toUpperCase();
            var secondReport = second.Name.toUpperCase();
            if (firstReport < secondReport) { return -1; }
            if (firstReport > secondReport) { return 1; }
            return 0;
        });
        return {
            reports: tmpOpt,
            templates: _templateReports,
            fileTypes: _outputTypes,
        };
    };

    componentDidMount() {

            kendo.ui.progress($(this.modalId), true);
            const papiDocsEnabled = this.isPapiPackingSlipEnabled();
            this.setState({ usePapiPackingSlips: papiDocsEnabled });
            this._allDocumentTemplates = [];

            if (!papiDocsEnabled) {
                const customerId = this.props.sharedSelectedOrderData
                    && this.props.sharedSelectedOrderData.CustomerId;
                Promise.all([
                    findOrdersService.initialPackingSlips(
                        this.props.sharedSelectedOrderData.CustomerId,
                        this.props.sharedSelectedOrderIds
                    ),
                    customerId
                        ? smallParcelService.getCustomersSettings([customerId]).catch(this.catchSettingsLoad)
                        : Promise.resolve(null),
                ]).then(([slipsResponse, settingsResponse]) => {
                    if (!slipsResponse) {
                        return;
                    }
                    const packaging = settingsResponse
                        && settingsResponse.data
                        && settingsResponse.data[0]
                        && settingsResponse.data[0].Options
                        && settingsResponse.data[0].Options.Packaging;
                    const mapped = this.applySsrsResponse(slipsResponse);
                    const savedRunner = (packaging
                        && (packaging.SmallParcelPackSlip || packaging.smallParcelPackSlip)) || "";
                    const savedAddress = (packaging
                        && (packaging.SmallParcelAddressTemplate || packaging.smallParcelAddressTemplate)) || null;
                    const matchedReport = (mapped.reports || []).find((r) => r.TemplatedRunner === savedRunner);
                    const matchedTemplate = (mapped.templates || []).find((t) => String(t.Id) === String(savedAddress));
                    this.setState({
                        optionsPackingReports: mapped.reports,
                        optionsTemplateReports: mapped.templates,
                        optionsOutputTypes: mapped.fileTypes,
                        indexOptionsPackingReports: matchedReport
                            ? matchedReport.TemplatedRunner
                            : (mapped.reports.length >= 1 ? mapped.reports[0].TemplatedRunner : 0),
                        indexOptionsTemplateReports: matchedTemplate
                            ? matchedTemplate.Id
                            : (mapped.templates.length >= 1 ? mapped.templates[0].Id : 0),
                        indexOptionsOutputTypes: mapped.fileTypes.length >= 1 ? mapped.fileTypes[0].Value : 0,
                    });
                }).finally(() => {
                    kendo.ui.progress($(this.modalId), false);
                });
                return;
            }

        const customerId = this.props.sharedSelectedOrderData
            && this.props.sharedSelectedOrderData.CustomerId;
        const selectedCustomerIds = this.getSelectedCustomerIds();
        const mixed = this.isMixedCustomers();
        const schemaPromise = smallParcelSettingsServices.getCarrierAccountSchema().catch(this.catchDocumentCatalog);
        const settingsPromise = selectedCustomerIds.length
            ? smallParcelService.getCustomersSettings(selectedCustomerIds.map(function (id) { return Number(id); })).catch(this.catchSettingsLoad)
            : Promise.resolve(null);

        Promise.all([schemaPromise, settingsPromise]).then(([schemaResponse, settingsResponse]) => {
            if (schemaResponse && schemaResponse.status == 200) {
                const parsedTemplates = papiDocumentUtil.parseDocumentTemplatesFromSchemaResponse(
                    schemaResponse.data
                );
                this._allDocumentTemplates = parsedTemplates == null
                    ? (this._allDocumentTemplates || [])
                    : parsedTemplates;
            }
            let packaging = null;
            let packagingList = [];
            if (settingsResponse && settingsResponse.data && settingsResponse.data.length > 0) {
                packagingList = settingsResponse.data.map(function (customer) {
                    return customer && customer.Options && customer.Options.Packaging;
                });
                packaging = packagingList[0];
            }
            const useNewPackingSlipFeatures = papiDocumentUtil.isCustomerUsingNewPackingSlipFeatures(packaging);
            if (!useNewPackingSlipFeatures) {
                const applyLegacy = (response) => {
                    if (!response) {
                        this.setState({ usePapiPackingSlips: false });
                        return;
                    }
                    const mapped = this.applySsrsResponse(response);
                    const savedRunner = (packaging
                        && (packaging.SmallParcelPackSlip || packaging.smallParcelPackSlip))
                        || "";
                    const savedAddress = (packaging
                        && (packaging.SmallParcelAddressTemplate || packaging.smallParcelAddressTemplate))
                        || null;
                    const matchedReport = (mapped.reports || []).find((r) => r.TemplatedRunner === savedRunner);
                    const matchedTemplate = (mapped.templates || []).find((t) => String(t.Id) === String(savedAddress));
                    this.setState({
                        optionsPackingReports: mapped.reports,
                        optionsTemplateReports: mapped.templates,
                        optionsOutputTypes: mapped.fileTypes,
                        indexOptionsPackingReports: matchedReport
                            ? matchedReport.TemplatedRunner
                            : (mapped.reports.length >= 1 ? mapped.reports[0].TemplatedRunner : 0),
                        indexOptionsTemplateReports: matchedTemplate
                            ? matchedTemplate.Id
                            : (mapped.templates.length >= 1 ? mapped.templates[0].Id : 0),
                        indexOptionsOutputTypes: mapped.fileTypes.length >= 1 ? mapped.fileTypes[0].Value : 0,
                        usePapiPackingSlips: false,
                    });
                };
                return findOrdersService.initialPackingSlips(customerId, this.props.sharedSelectedOrderIds)
                    .then((response) => applyLegacy(response))
                    .catch(this.catchDocumentCatalog);
            }
            let fmt;
            let savedValue;
            let savedScope;
            if (mixed) {
                const sharedFormat = papiDocumentUtil.resolveSharedPackagingValue(
                    packagingList,
                    "SmallParcelPapiPackSlipFormat"
                );
                fmt = sharedFormat === "pdf" || sharedFormat === "zpl" ? sharedFormat : "pdf";
                // Several customers: start on Unspecified. Generate stays off until a slip is chosen.
                savedValue = null;
                savedScope = papiDocumentUtil.resolveSharedPackagingValue(
                    packagingList,
                    "SmallParcelPapiPackSlipScope"
                ) || "shipment";
            } else {
                fmt = papiDocumentUtil.resolvePapiDocumentFormat(packaging || {}, "packingSlip");
                savedValue = papiDocumentUtil.resolveSavedDocumentValue(packaging || {}, "packingSlip");
                savedScope = (packaging && (packaging.SmallParcelPapiPackSlipScope
                    || packaging.smallParcelPapiPackSlipScope)) || "shipment";
            }
            const formatOptions = papiDocumentUtil.getFormatOptions(false);
            // Unspecified has no slip yet, so the list stays unfiltered (PDF shows every
            // slip). The shared format is applied once a slip that supports it is chosen.
            const listFormat = (mixed && !savedValue) ? "pdf" : fmt;
            const rebuilt = this.rebuildTypeOptions(listFormat, savedValue, !mixed);
            this.setState({
                optionsPackingReports: rebuilt.options,
                optionsTemplateReports: [],
                optionsOutputTypes: formatOptions,
                indexSelectedFormat: fmt,
                indexOptionsPackingReports: mixed ? (rebuilt.selection.value || "") : rebuilt.selection.value,
                indexOptionsTemplateReports: 0,
                indexOptionsOutputTypes: fmt === "zpl" ? "text/plain" : "application/pdf",
                indexPapiPackSlipScope: savedScope,
                usePapiPackingSlips: true,
            });
        }).finally(() => {
            kendo.ui.progress($(this.modalId), false);
        });
    }

    handleChangeEvent = (e) => {
        if (e.target.name === "indexOptionsPackingReports" && this.state.usePapiPackingSlips) {
            this.applyPackingSlipSelection(e.target.value);
            return;
        }
        this.setState({ [e.target.name]: e.target.value });
    }

    applyPackingSlipSelection = (value) => {
        const mixed = this.isMixedCustomers();
        if (!papiDocumentUtil.isPapiSelection(value)) {
            const rebuilt = this.rebuildTypeOptions("pdf", null, false);
            this.setState({
                optionsPackingReports: rebuilt.options,
                indexOptionsPackingReports: mixed ? "" : null,
            });
            return;
        }
        const formatOptions = papiDocumentUtil.getFormatOptionsForTemplate(
            value,
            this._allDocumentTemplates,
            papiDocumentUtil.PAPI_DOC_TYPES.packingSlip
        );
        let fmt = this.state.indexSelectedFormat;
        if (!formatOptions.some(function (opt) { return opt.Value === fmt; })) {
            fmt = (formatOptions[0] && formatOptions[0].Value) || "pdf";
        }
        const rebuilt = this.rebuildTypeOptions(fmt, value, false);
        this.setState({
            indexSelectedFormat: fmt,
            indexOptionsOutputTypes: papiDocumentUtil.toSsrsOutputType(fmt),
            optionsPackingReports: rebuilt.options,
            indexOptionsPackingReports: rebuilt.selection.value || value,
        });
    }

    handleFormatChange = (e) => {
        const fmt = e.target.value;
        const mixed = this.isMixedCustomers();
        const current = this.state.indexOptionsPackingReports;
        // Keep the current slip when it can print in the new format. Otherwise
        // select the first slip in the filtered list, not Unspecified.
        const rebuilt = this.rebuildTypeOptions(fmt, current, true);
        if (!rebuilt.selection.value) {
            const fallback = this.rebuildTypeOptions("pdf", current, false);
            const nextValue = fallback.selection.value;
            this.setState({
                indexSelectedFormat: "pdf",
                indexOptionsOutputTypes: papiDocumentUtil.toSsrsOutputType("pdf"),
                optionsPackingReports: fallback.options,
                indexOptionsPackingReports: mixed ? (nextValue || "") : nextValue,
            });
            return;
        }
        this.setState({
            indexSelectedFormat: fmt,
            indexOptionsOutputTypes: papiDocumentUtil.toSsrsOutputType(fmt),
            optionsPackingReports: rebuilt.options,
            indexOptionsPackingReports: mixed ? (rebuilt.selection.value || "") : rebuilt.selection.value,
        });
    }

    clickExportReport = () => {
        const parsed = papiDocumentUtil.parseDocOptionValue(this.state.indexOptionsPackingReports);
        if (parsed.engine === papiDocumentUtil.DOC_ENGINE_PAPI) {
            this.generatePapiPackingSlip(parsed.rawId);
            return;
        }

        if (this.isMixedCustomers()) {
            return;
        }

        this.setState({ gifPackageSlips: true });

        const templatedRunner = this.state.indexOptionsPackingReports;
        const outputType = this.state.usePapiPackingSlips
            ? papiDocumentUtil.toSsrsOutputType(this.state.indexSelectedFormat || this.state.indexOptionsOutputTypes)
            : this.state.indexOptionsOutputTypes;

        let payload_runReportObj = {
            "TemplatedRunner": templatedRunner,
            "TransactionIds": this.props.sharedSelectedOrderIds,
            "CustomerId": this.props.sharedSelectedOrderData.CustomerId,
            "TemplateId": this.state.indexOptionsTemplateReports,
            "OutputType": outputType
        }
        findOrdersService.PackingSlipReportStarter(payload_runReportObj).then((response) => {

            this.setState({ gifPackageSlips: false });
            console.log("PackingSlipReportStarter response",response);
            if(response && response.status == 200){
                let fileExt = 'pdf';
                const mime = String(outputType || "");
                if (mime.indexOf('csv') != -1) {
                    fileExt = 'csv';
                } else if (mime.indexOf('excel') != -1) {
                    fileExt = 'xls';
                } else if (mime.indexOf('xml') != -1) {
                    fileExt = 'xml';
                } else if (mime.indexOf('msword') != -1) {
                    fileExt = 'docx';
                }
                response.data.outputType = fileExt;
                // showing moving icon animation start
                var targetElement = $('#generateSlip'+this.props.windowId);
                this.$rootScope.animationMoveIcon(targetElement);
                this.$rootScope.taskStarted();
                // this.$rootScope.$broadcast("EventProgressPackingSlips", response.data);
                response.data.type = "packingslips";
                var event = new CustomEvent("showProgressModal", {
                    detail: response.data
                });
                document.dispatchEvent(event);

            }

            // let date = new Date();
            // let day = date.getDate();
            // let month = date.getMonth();
            // let year = date.getFullYear();

            // if (this.state.indexOptionsOutputTypes.indexOf('pdf') != -1) {

            //     let blob = ArrayWms.convertBase64ToByteArray(response, this.state.indexOptionsOutputTypes);
            //     ArrayWms.displayBlobInWindow(blob, 'report.pdf');

            // } else if (this.state.indexOptionsOutputTypes.indexOf('csv') != -1) {

            //     let blob = ArrayWms.convertBase64ToByteArray(response, this.state.indexOptionsOutputTypes);
            //     saveAs(blob, "PackingSlips" + month + "_" + day + "_" + year + ".csv");

            // } else if (this.state.indexOptionsOutputTypes.indexOf('excel') != -1) {

            //     let blob = ArrayWms.convertBase64ToByteArray(response, this.state.indexOptionsOutputTypes);
            //     saveAs(blob, "PackingSlips" + month + "_" + day + "_" + year + ".xls");

            // } else if (this.state.indexOptionsOutputTypes.indexOf('xml') != -1) {

            //     let blob = ArrayWms.convertBase64ToByteArray(response, this.state.indexOptionsOutputTypes);
            //     saveAs(blob, "PackingSlips" + month + "_" + day + "_" + year + ".xml");

            // } else if (this.state.indexOptionsOutputTypes.indexOf('msword') != -1) {

            //     let blob = ArrayWms.convertBase64ToByteArray(response, this.state.indexOptionsOutputTypes);
            //     saveAs(blob, "PackingSlips" + month + "_" + day + "_" + year + ".doc");

            // }
        }).finally(() => {
            this.setState({ gifPackageSlips: false });
            kendo.ui.progress($(this.modalId), false);
            this.props.onClose();
        });
    }

    generatePapiPackingSlip = (templateId) => {
        this.setState({ gifPackageSlips: true });

        const resolvedTemplateId = templateId || papiDocumentUtil.parseDocOptionValue(
            this.state.indexOptionsPackingReports
        ).rawId;
        const templateVersion = papiDocumentUtil.findPapiTemplateVersion(
            this.state.optionsPackingReports,
            resolvedTemplateId
        );

        const outputFormat = papiDocumentUtil.normalizeDocumentFormat(this.state.indexSelectedFormat) || "pdf";

        const payload = papiDocumentUtil.buildPapiPackingSlipGeneratePayload({
            transactionIds: this.props.sharedSelectedOrderIds,
            customerId: this.props.sharedSelectedOrderData.CustomerId,
            customerIds: this.getSelectedCustomerIds(),
            templateId: resolvedTemplateId,
            templateVersion: templateVersion,
            outputFormat: outputFormat,
            papiSlipScope: this.state.indexPapiPackSlipScope || "shipment",
        });

        findOrdersService.PapiPackingSlipReportGenerate(payload).then((response) => {
            if (response && response.status === 200 && response.data) {
                if (outputFormat === "zpl") {
                    const zplText = papiDocumentUtil.decodeZplResponseData(response.data);
                    GlobalService.printDataInZplPrinter(zplText);
                } else {
                    // First render and stored reprint share this endpoint; skip vs preview
                    // is qz_silent_pdf_print, not whether PAPI was called.
                    GlobalService.printOrViewPackingSlipPdf(response.data);
                }
                this.setState({ gifPackageSlips: false });
                kendo.ui.progress($(this.modalId), false);
                this.props.onClose();
                return;
            }

            GlobalService.notification(
                'error',
                this.translate('Label_Packing_Slip'),
                this.translate('Label_Packing_Slips_Generate_Error')
            );
        }).catch((error) => {
            // The request uses responseType:'arraybuffer', so error bodies arrive as
            // raw bytes rather than a parsed object. Decode and extract the WMS
            // ErrorResponse.Descriptions before falling back to the generic message.
            const message = papiDocumentUtil.extractPapiErrorMessage(error)
                || this.translate('Label_Packing_Slips_Generate_Error');
            GlobalService.notification('error', this.translate('Label_Packing_Slip'), message);
        }).finally(() => {
            this.setState({ gifPackageSlips: false });
            kendo.ui.progress($(this.modalId), false);
        });
    }

    getAnyNotFullyPackageAllocated = () => {
        if (this.props.sharedAnyNotFullyPackageAllocated === true) {
            return true;
        }
        var d = this.props.sharedSelectedOrderData;
        if (d && d.FullyPackageAllocated === false) {
            return true;
        }
        if (d && d.ReadOnly && d.ReadOnly.FullyPackageAllocated === false) {
            return true;
        }
        return false;
    };

    isPapiPackageLayoutBlocked = () => {
        return papiDocumentUtil.shouldDisablePapiPackingSlipsForSelection(
            papiDocumentUtil.isPapiSelection(this.state.indexOptionsPackingReports),
            papiDocumentUtil.isPapiPackageSlipScope(this.state.indexPapiPackSlipScope),
            this.getAnyNotFullyPackageAllocated()
        );
    };

    render() {
        const isPapiPackageLayoutBlocked = this.isPapiPackageLayoutBlocked();
        const settingsBlocked = this.state.packingSlipSettingsFailed && this.isMixedCustomers();
        return (
            <WmsModel
                id={this.props.windowId + 'shipSlipsModel'}
                class='shipSlipsModel'
                title={this.translate('Label_Packing_Slip')}
                width={400}
                height={460}
                onCloseFunc={this.props.onClose}
                isOpen={this.props.sharedIsOpenPackingSlipsModel}
                customClass='wms-model-new-ui-wrapper'>
                <div className="model-content-wrapper">
                <WmsContainer title={
                    this.translate('FindOrders_Lbl_Customer') + ': ' +
                    (this.isMixedCustomers()
                        ? this.translate('Label_Multiple_Values')
                        : (this.props.sharedSelectedOrderData != null ? this.props.sharedSelectedOrderData.Customer : ''))
                }>

                    <WmsDropdown
                        id="indexOptionsPackingReports"
                        name="indexOptionsPackingReports"
                        label={this.state.usePapiPackingSlips
                            ? this.translate('Label_Papi_Document_Template')
                            : this.translate('Label_Packing_Slip_Type')}
                        wmsSelector={this.state.selector + "PackingSlipReport"}
                        value={this.state.indexOptionsPackingReports}
                        onChangeFunc={this.handleChangeEvent}
                        options={this.state.optionsPackingReports}
                        textField='Name'
                        valueField={this.state.usePapiPackingSlips ? 'value' : 'TemplatedRunner'}
                        blankFirstOption={this.isMixedCustomers() && this.state.usePapiPackingSlips}
                        blankFirstOptionText="Unspecified"
                    />
                    {papiDocumentUtil.isPapiSelection(this.state.indexOptionsPackingReports) && (
                    <WmsDropdown
                        id="indexSelectedFormat"
                        name="indexSelectedFormat"
                        label={this.translate('Label_Packing_Slip_Format')}
                        wmsSelector={this.state.selector + "OutputType"}
                        value={this.state.indexSelectedFormat}
                        onChangeFunc={this.handleFormatChange}
                        options={this.state.optionsOutputTypes}
                        textField='Name'
                        valueField='Value'
                    />
                    )}
                    {papiDocumentUtil.isPapiSelection(this.state.indexOptionsPackingReports) && (
                    <WmsDropdown
                        id="indexPapiPackSlipScope"
                        name="indexPapiPackSlipScope"
                        label={this.translate("Label_PapiPackSlipLayout")}
                        showLabelInfoIcon={true}
                        labelInfoTooltipText={this.translate("Tooltip_PapiPackSlipLayout")}
                        wmsSelector={this.state.selector + "PapiPackSlipLayout"}
                        value={this.state.indexPapiPackSlipScope || "shipment"}
                        onChangeFunc={this.handleChangeEvent}
                        options={this.optionsPapiPackSlipScope}
                        valueField="value"
                        textField="text"
                    />
                    )}
                    {!this.state.usePapiPackingSlips && (
                    <WmsDropdown
                        id="indexOptionsTemplateReports"
                        name="indexOptionsTemplateReports"
                        label={this.translate('Label_Packing_Slip_Address_Configuration')}
                        wmsSelector={this.state.selector + "indexOptionsTemplateReports"}
                        value={this.state.indexOptionsTemplateReports}
                        onChangeFunc={this.handleChangeEvent}
                        options={this.state.optionsTemplateReports}
                        textField='Name'
                        valueField='Id'
                    />
                    )}
                    {!this.state.usePapiPackingSlips && (
                    <WmsDropdown
                        id="indexOptionsOutputTypes"
                        name="indexOptionsOutputTypes"
                        label={this.translate('Label_Packing_Slip_Format')}
                        wmsSelector={this.state.selector + "OutputType"}
                        value={this.state.indexOptionsOutputTypes}
                        onChangeFunc={this.handleChangeEvent}
                        options={this.state.optionsOutputTypes}
                        textField='Name'
                        valueField='Value'
                    />
                    )}
                </WmsContainer>

                </div>
                <div className="footer-btn-holder">
                    <WmsButton
                        label={this.translate("Label_Cancel")}
                        wmsSelector={this.state.selector + "SlipExit"}
                        onClickFunc={this.props.onClose}
                        buttonType='yellow'
                        icon={'fa-ban'}
                    />
                    <WmsButton
                        label={this.translate('Label_Generate')}
                        wmsSelector={this.state.selector + "GenerateSlip"}
                        id={"generateSlip"+this.props.windowId}
                        onClickFunc={this.clickExportReport}
                        disabled={this.state.gifPackageSlips
                            || settingsBlocked
                            || (this.state.usePapiPackingSlips && !papiDocumentUtil.isPapiSelection(this.state.indexOptionsPackingReports))
                            || isPapiPackageLayoutBlocked}
                        showToolTip={isPapiPackageLayoutBlocked}
                        tooltipText={isPapiPackageLayoutBlocked
                            ? this.translate("Label_Packing_Slips_Must_Be_Packed")
                            : ""}
                        loading={this.state.gifPackageSlips}
                        icon={'fa-check-square-o'}
                    />

                </div>


            </WmsModel>
        )
    }
}